export const SCENARIO_COPY = {
  title: 'Speak to your agent',
  subtitle:
    'Your agent has already learned from your website. Try asking some of these questions:',
  exampleQuestions: [
    '"What are your opening hours?"',
    '"Do you offer [service/product from FAQ]?"',
    '"Can you help me update my booking for tomorrow?"',
  ],
  scenarios: {
    title: 'Guided scenarios',
    description:
      'Follow this example as if you were a customer. Your agent will handle it just like in real life',
    items: [
      {
        title: 'Scenario: Checking an order',
        say: 'What are your opening hours?',
        details: ['Order ID: GB-010237845', 'Customer name: John Doe'],
      },
      {
        title: 'Scenario: Product inquiry',
        say: 'Do you have this product in stock?',
        details: ['Product: Specific product', 'Customer name: John Doe'],
      },
      {
        title: 'Booking update',
        say: 'Can you help me update my booking for tomorrow?',
        details: [
          'Current booking: Tomorrow 2pm',
          'Requested change: 4pm',
          'Customer: Existing booking',
        ],
      },
    ],
    toggleShow: 'See guided scenarios',
  },
  call: {
    start: 'Start test call',
    stop: 'End call',
  },
  agentStudio: {
    text: 'Ready to customize your agent further?',
    button: 'Go to Agent Studio',
  },
} as const;

export type ScenarioCopy = typeof SCENARIO_COPY;
